import Vue from 'vue'
import _ from 'lodash'

const updateValuesFromStore = {
    install(Vue, options) {
        Vue.prototype.$updateValuesFromStore = function() {
            _.each(this.formValues, (value, key) => {
                // key is set, values are different, store value different from null
                if (this.values[key] !== undefined && this.values[key] !== value && value !== null) {
                    this.values[key] = value
                }
            })
        }
    }
}

export default updateValuesFromStore


// WEBPACK FOOTER //
// ./src/plugins/updateValuesFromStore.js